// packages import
import { Box, Grid } from '@mui/material'
import { FC, useState } from 'react'
import { useParams } from 'react-router-dom'

// components import
import BillTimeline from '../../../components/billing/billDetail/BillTimeline'
import BillPreview from '../../../components/billing/billDetail/BillPreview'

// others
import FundRequestDetailHeader from '../../../components/billing/fundRequestDetail/FundRequestDetailHeader'
import { FINAL_FUND_REQUEST_STATUSES } from '../../../constants'
import BillClientMenu from '../../../components/billing/billDetail/BillClientMenu'
import useFetchBillDetails from '../../../hooks/useFetchBillDetails'
import { BillStatus } from '../../../../generated'

const FundRequestDetail: FC = (): JSX.Element => {
  const [selectedClientId, setSelectedClientId] = useState<string>()
  const { id: billId } = useParams<{ id: string }>()

  const { bill, clientData, refetch } = useFetchBillDetails({
    billId: billId ? parseInt(billId) : undefined,
    selectedClientId,
    includeInterest: false,
    setInitialClientId: setSelectedClientId
  })

  const { case: caseData, billTimelines = [] } = bill || {}
  const isSplitBill = caseData?.billing?.splitBillEnabled
  const isFinalFundRequest =
    bill?.status &&
    (FINAL_FUND_REQUEST_STATUSES.includes(bill.status) || (bill.status === BillStatus.Billed && !bill.sendToClient))

  const accessTokens = bill?.accessTokens || []
  const selectedAccessToken = accessTokens.find(token => token.client?.id === selectedClientId) || accessTokens[0]

  const handleClientSelect = (clientId: string) => {
    setSelectedClientId(clientId)
  }

  return (
    <Box py={1}>
      <FundRequestDetailHeader
        bill={bill}
        clientId={selectedAccessToken?.client?.id}
        clientPayableAmount={clientData?.payableAmount}
        onRefetch={refetch}
      />

      <Grid container spacing={5}>
        <Grid item xs={12} lg={5}>
          {isSplitBill && isFinalFundRequest && accessTokens.length > 0 && (
            <BillClientMenu bill={bill} selectedClientId={selectedClientId} onClientSelect={handleClientSelect} />
          )}

          <BillTimeline title="Timeline" billTimelines={billTimelines} />
        </Grid>

        <Grid item xs={12} lg={7}>
          <BillPreview
            bill={bill}
            client={selectedAccessToken?.client}
            selectedAccessToken={{ token: selectedAccessToken?.token, amount: selectedAccessToken?.amount }}
            clientData={clientData}
            isFinalBill={isFinalFundRequest}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default FundRequestDetail
